import { render, staticRenderFns } from "./PaidSitesIndex.vue?vue&type=template&id=59c77a70&"
import script from "./PaidSitesIndex.vue?vue&type=script&lang=js&"
export * from "./PaidSitesIndex.vue?vue&type=script&lang=js&"
import style0 from "./PaidSitesIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports